import CompanyActions from '../actions/CompanyCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';

const initialState = {
  entities: [],
  busy: false,
};

export default function company(state = initialState, action) {
  switch (action.type) {
    case CompanyActions.busyAction: return setBusy(state);
    case CompanyActions.retrievedAllAction: {
      return {
        ...state,
        busy: false,
        entities: action.entities.companies,
      };
    }
    case CompanyActions.retrievedAction: {
      const updatedEntities = state.entities.map(entity => {
        if (entity.id === action.entity.companyId) {
          return {
            ...entity,
          };
        }
        return entity;
      });
      return {
        ...state,
        entities: updatedEntities,
        busy: false,
      };
    }
    case Actions.UNBUSY: return setUnBusy(state);
    case Actions.RESET: return initialState;
    default: return state;
  }
}
